export const whitelabelConfig = {
  short: 'whitelabelapi',
  storeName: 'Whitelabel Online Store',
  assetUrl: '/whitelabel/greenstorm/',

  company: ' SST Touristik-Vertrieb GmbH',
  analyticsId: 'NOOP',
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/greenstorm/greenstorm-logo.svg',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/greenstorm/greenstorm-logo-white.svg',
  //  logoHeader: () => require('@/assets/greenstorm-logo.svg'),
  //  logoFooter: () => require('@/assets/greenstorm-logo-white.svg'),
  isStandalone: true,
  showHeader: true,
  showHeaderLogo: true,
  showFooterLogo: true,
  hasNewsletterOptin: true,
  showTotalPrice: true,
  heroTitle: 'Clever & einfach reisen mit Urlaubsgut<wbr>scheinen!',
  hasHeroSubtitle: false,
  showReduction: true,
  heroSubtitle: '',
  hasHeroAddition: true,
  heroAdditionText:
    'Gutscheine sind 3 Jahre gültig&nbsp; <br> Mit Geld-zurück-Garantie!&nbsp;',
  heroBadge: {
    file: 'badge-70p.svg',
  },
  homepage: {
    advantages: 'large',
  },
  supportPhone: '+43 5372 66 888',
  supportMail: 'office@greenstorm.eu',
  fixedNavbar: true,
  heroImageResolution: {
    xl: {width: 1650, height: 600, crop: 'south'},
    l: {width: 1152, height: 450, crop: 'south'},
    m: {width: 960, height: 400, crop: 'south'},
    s: {width: 1024, height: 380, crop: 'south'},
    xs: {width: 700, height: 400, crop: 'south'},
  },

  showPromoNotification: true,
  iconUrl: '/img/icons/default/',

  heroInfoText:
    'Mit einem Urlaubsgutschein kaufen Sie einen Kurzurlaub mit bis zu 70% Ersparnis. Egal ob eine tolle Städtereise, ein exklusiver Wellnessurlaub oder ein unvergesslicher Wanderurlaub in den Bergen - hier finden Sie das richtige Reiseschnäppchen!',
  styleOverride: () => import('@/styles/styles.scss'),
  tagManager: {
    id: 'GTM-5FJ556',
    mode: 'ua', //ua || default (default = ecommerce app+web; ua =  enhanced ecommerce ua)
    brand: 'we-are.travel Urlaubsgutscheine',
  },
}
